module.exports = __webpack_public_path__ + "img/C03TechHeadHunting_ua.1ad34b49.webp";